const ITEMS = ["Private Physiotherapie", "Nur Hausbesuche", "Dachau & Umgebung", "Krankengymnastik", "Manuelle Therapie", "Massage", "Lymphdrainage"];

export const Marquee = () => (
  <section className="relative bg-[#060606] text-white py-8 sm:py-10 overflow-hidden border-y border-white/10" data-testid="marquee">
    <div className="flex whitespace-nowrap animate-marquee">
      {[0, 1].map((k) => (
        <div key={k} className="flex items-center shrink-0" aria-hidden={k === 1}>
          {ITEMS.map((t, i) => (
            <span key={i} className="flex items-center font-display text-xl sm:text-2xl tracking-[0.15em] uppercase text-neutral-300">
              <span className="px-6 sm:px-9">{t}</span>
              <span className="text-[var(--pmr-red)]">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
